import React, { useState, useMemo } from "react";
import { Editor } from "react-draft-wysiwyg";
import "../../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import {
  ContentState,
  EditorState,
  convertToRaw,
} from "draft-js";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import "./EditorRichText.scss";
import { useContent } from "contexts/contentContext/contentContext.js";
//import { stateFromHTML } from "draft-js-import-html";
//import { convertToHTML } from "draft-convert";

const EditorRichText = ({ oldState, setHtmlValue }) => {
  const { getDirection } = useContent();
  const [editorState, setEditorState] = useState(null);
  const handleChangeState = (editorState) => {
    setEditorState(editorState);
    //convert to html
    const html = editorState.getCurrentContent();
    const row = convertToRaw(html);
    const htmlState = draftToHtml(row);
    //convert state to html value
    setHtmlValue(htmlState);
  };

  useMemo(() => {
    if (oldState) {
      //convert html to editorState
      const contentBlock = htmlToDraft(oldState);
      if (contentBlock) {
        const contentState = ContentState.createFromBlockArray(
          contentBlock.contentBlocks
        );
        const editorState = EditorState.createWithContent(contentState);
        setEditorState(editorState);
      }
    }
  }, [oldState]);

  return (
    <div
      className={`editor-rich-text ${
        getDirection() === "rtl" ? "editor-rich-text-rtl" : ""
      }`}
    >
      <Editor
        editorState={editorState}
        //wrapperClassName="demo-wrapper"
        editorClassName="demo-editor"
        onEditorStateChange={handleChangeState}
        toolbar={{
          //options: ['inline', 'fontSize', 'fontFamily', 'list', 'textAlign', 'colorPicker', 'link', 'emoji', 'history'],
          textAlign: {
            inDropdown: true,
          },
        }}
      />
    </div>
  );
};

export default EditorRichText;
